/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const INIT_BIAXIAL_HORIZONTAL_STRIP_PROGRAM_SCREEN =
    'INIT_BIAXIAL_HORIZONTAL_STRIP_PROGRAM_SCREEN';

export const INIT_AND_RESET_BIAXIAL_VERTICAL_STRIP_PROGRAM_SCREEN =
    'INIT_AND_RESET_BIAXIAL_VERTICAL_STRIP_PROGRAM_SCREEN';

export const RESET_BIAXIAL_HORIZONTAL_STRIP_PROGRAM_SCREEN =
    'RESET_BIAXIAL_HORIZONTAL_STRIP_PROGRAM_SCREEN';

export const SET_CURRENT_HIGHLIGHT_INDEX_PROGRAM_SCREEN =
    'SET_CURRENT_HIGHLIGHT_INDEX_PROGRAM_SCREEN';

export const SET_CURRENT_VERTICAL_HIGHLIGHT_INDEX_PROGRAM_SCREEN =
    'SET_CURRENT_VERTICAL_HIGHLIGHT_INDEX_PROGRAM_SCREEN';

export const SET_PROGRAM_SCREEN_CARET = 'SET_PROGRAM_SCREEN_CARET';

export const SET_GRADIENT_FOR_PROGRAM_SCREEN = 'SET_GRADIENT_FOR_PROGRAM_SCREEN';

export const SET_CURRENT_TOTAL_ITEMS_PROGRAM_SCREEN = 'SET_CURRENT_TOTAL_ITEMS_PROGRAM_SCREEN';

export const SET_HORIZONTAL_OPTIONS_PROGRAM_SCREEN = 'SET_HORIZONTAL_OPTIONS_PROGRAM_SCREEN';

export const SET_RIGHT_GRADIENT_VISIBILITY = 'SET_RIGHT_GRADIENT_VISIBILITY';

export const SET_LEFT_GRADIENT_VISIBILITY = 'SET_LEFT_GRADIENT_VISIBILITY';

export const SET_VIEW_ALL_DIRECTION_PROGRAM_SCREEN = 'SET_VIEW_ALL_DIRECTION_PROGRAM_SCREEN';
